/* Copyright (c) 2017 Backpack Health LLC */
/* global window */

import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { LargePreferredLanguageDropdownList } from '../../../components/LanguageDropdownList';

import { publicPasscode } from '../../../../utilities/LocalStorage';
import IconLock from '../../../components/icons/IconLock';
import COLORS from '../../../styles/Colors';

import './PasscodeEntry.scss';
import PublicShareCardFooter from '../PublicShareCard/PublicShareCardFooter';
import { actions as localeActions } from '../../../redux/ducks/locale';

interface State {
  passcode: string;
  phraseErrorId: string;
}

interface Props {
  hash: string;
  onSubmit(passcode, callback): void;
  onSuccess(response): void;
  onNotFound(): void;
  setWindowTitlePhrase(phrase: object): void;
}


function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    setWindowTitlePhrase: (phrase) => {
      dispatch(localeActions.setWindowTitlePhrase([phrase]));
    },
  };
}

class PasscodeEntry extends React.Component<Props, State> {

  state: State = {
    passcode: '',
    phraseErrorId: '',
  };

  private inputRef: HTMLInputElement;

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangePasscode = this.onChangePasscode.bind(this);
  }

  componentDidMount() {
    this.props.setWindowTitlePhrase({ id: 'shareCardURLCode.page.title' });
  }

  handleSubmit() {
    const encodedPasscode = window.btoa(`:${this.state.passcode}`);

    this.props.onSubmit(encodedPasscode, (apiError, res) => {
      if (apiError) {
        this.inputRef && this.inputRef.setSelectionRange(0, this.state.passcode.length);

        if (apiError.isNotFound()) {
          this.props.onNotFound();
        } else {
          this.setState({
            phraseErrorId: 'shareCardURLCode.invalidCode.error.text',
          });
        }
      } else {
        publicPasscode.set(this.state.passcode);
        this.props.onSuccess(res);
      }
    });
  }

  onChangePasscode(e) {
    e.preventDefault();
    const passcode = e.target.value.substr(0, 4).replace(/[^0-9]+/g, '');
    const oldPasscode = this.state.passcode;
    const passcodeIsDifferent = oldPasscode !== passcode;
    const phraseErrorId = passcodeIsDifferent ? '' : this.state.phraseErrorId;
    this.setState({ passcode, phraseErrorId }, () => {
      if (passcode.length === 4 && passcodeIsDifferent) {
        this.handleSubmit();
      }
    });
  }

  render() {
    return (
      <div className="page-passcode">

        <div className="page-passcode-controls">
          <LargePreferredLanguageDropdownList htmlId="pageLanguage" color="white" />
        </div>

        <div className="page-passcodemain">
          <div className="page-passcodemain-header">
            <div className="page-passcodemain-lock">
              <IconLock.Medium fill={COLORS.gsMiddleLT} />
            </div>
          </div>
          <form className="page-passcodemain-content" onSubmit={(e) => { e.preventDefault(); }}>
            <label htmlFor="passcode">
              <FormattedMessage id="shareCardURLCode.accessCode.field.label" />
            </label>
            <input
              id="passcode"
              ref={(r) => { this.inputRef = r; }}
              className="cmp-passcodeinput"
              value={this.state.passcode}
              onChange={this.onChangePasscode}
              name="passcode"
              autoComplete="off"
              type="tel"
              autoFocus={true}
            />

            <input type="submit" style={{ display: 'none' }} />

            {
              this.state.phraseErrorId && (
                <div className="cmp-passcodeinput-error">
                  <FormattedMessage id={this.state.phraseErrorId} />
                </div>
              )
            }

          </form>
        </div>

        <PublicShareCardFooter white style={{ padding: '0 24px' }}/>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PasscodeEntry);
